import { useAppSelector } from "./redux";
import { useMembershipLevel } from "./membership";

const useMemberInfo = () => {
  const { userInfo } = useAppSelector((state) => state.globalReducer);
  const { membershipLevel } = useMembershipLevel();
  return { ...userInfo, level: membershipLevel };
};
export default useMemberInfo;
